'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.notificationSettings',
configs:[
require('./notificationSettingsConfig')],

components:[
require('./notificationSettingsController'),
require('./components/groupsNotificationSettingsSubviewDirective/groupsNotificationSettingsSubviewDirective'),
require('./components/groupNotificationSettingsDirective/groupNotificationSettingsDirective'),
require('./components/groupNotificationSettingsDirective/toggleNotificationsCheckboxDirective'),
require('./components/doNotDisturbNotificationSettings/doNotDisturbNotificationSettingsDirective'),
require('./components/doNotDisturbNotificationSettings/directives/doNotDisturbScheduleItemDirective'),
require('./components/doNotDisturbNotificationSettings/modals/addDoNotDisturbScheduleModalController'),
require('./components/doNotDisturbNotificationSettings/modals/addForwardingAddressModalController'),
require('./components/doNotDisturbNotificationSettings/modals/editForwardingAddressModalController'),
require('./components/doNotDisturbNotificationSettings/modals/deleteForwardingAddressModalController')]});
//# sourceMappingURL=index.js.map
